<template>
  <v-card class="card-border" max-width="800">
    <v-card-title class="justify-center">Rank de Usados</v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        sort-by="posicaoUsados"
        hide-default-footer
        :items-per-page="10"
      >
        <template v-slot:item.variacaoUsados="{ item }">
          <v-btn icon v-if="item.variacaoUsados > 0">
            <v-icon color="#75C00E">mdi-arrow-up-bold</v-icon>
            +{{ item.variacaoUsados }}
          </v-btn>
          <v-btn icon v-else-if="item.variacaoUsados < 0">
            <v-icon color="#DB2832">mdi-arrow-down-bold</v-icon>
            {{ item.variacaoUsados }}
          </v-btn>
        </template>

        <template v-slot:item.posicaoUsados="{ item }">{{ item.posicaoUsados }}ª</template>

        <template v-slot:footer>
          <v-row justify="center">
            <v-col cols="1">
              <v-btn
                outlined
                color="blue darken-2"
                rounded
                dark
                depressed
                small
                @click="$refs.dialogRankUsados.show(items)"
              >Expandir</v-btn>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-card-text>
    <DialogRankUsados ref="dialogRankUsados" />
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "RankUsados",

  components: {
    DialogRankUsados: () => import("./DialogRankUsados")
  },

  data() {
    return {
      headers: [
        { text: "", value: "variacaoUsados", sortable: false, align: "end" },
        {
          text: "Posição",
          value: "posicaoUsados",
          sortable: false,
          align: "center"
        },
        { text: "Empresa", value: "apelido", sortable: false, align: "center" },
        { text: "Nome", value: "nome", sortable: false, align: "start" },
        {
          text: "Quantidade",
          value: "usados",
          sortable: false,
          align: "center"
        }
      ],
      items: []
    };
  },

  computed: {
    ...mapGetters("dashboard", ["getRankUsados"]),
    ...mapGetters("dashboard", ["getEmpresas"])
  },

  methods: {
    clearGrafic() {
      this.items = [];
    },

    generateGrafic(rank) {
      for (let i = 0; i < rank.length; i++) {
        const apelido = this.getEmpresas.filter(
          empresa => empresa.cnpj == rank[i].empresa
        )[0].apelido;
        rank[i].apelido = apelido;
      }
      this.items = rank;
    }
  },

  watch: {
    getRankUsados(rank) {
      this.clearGrafic();
      this.generateGrafic(rank);
    }
  },

  mounted() {
    if (this.getRankUsados.length !== 0) {
      this.clearGrafic();
      this.generateGrafic(this.getRankUsados);
    }
  }
};
</script>
